import { ethers } from 'ethers'

/**
 * Checks if two Ethereum addresses are the same.
 * @param addressA - First address to compare.
 * @param addressB - Second address to compare.
 * @returns true if both addresses are the same, false otherwise.
 */
export const areAddressesEqual = (
  addressA?: string,
  addressB?: string
): boolean => {
  if (!addressA || !addressB) return false
  if (!ethers.utils.isAddress(addressA) || !ethers.utils.isAddress(addressB)) {
    throw new Error('Invalid Ethereum address provided.')
  }

  return ethers.utils.getAddress(addressA) === ethers.utils.getAddress(addressB)
}
